export const GTM_ID = 'GTM-NFZNVLS6' as const;
